import React from 'react';
import { Link } from 'react-router-dom';

import Img1 from '../../images/laura-about-1.svg';
import Img2 from '../../images/laura-about-2.svg';

import paws1 from '../../images/paws-1.svg';
import paws2 from '../../images/paws-2.svg';
import paws3 from '../../images/paws-2.svg';
import paws4 from '../../images/paws-2.svg';


const ClickHandler = () => {
    window.scrollTo(10, 0);
}


function Hero(props) {
    return (
        <section className={"hero-section " + props.hclass}>
            <div className="container">
                <div className="row align-items-center">
                    <div className="col-lg-6">
                        <div className="hero-content">
                            <h2>Comprendre, équilibrer, avancer ... à pattes égales</h2>
                            <p>Un accompagnement en éducation et comportement canin pour mieux comprendre le chien et créer, main dans la patte, une relation harmonieuse et durable.</p>
                            <Link onClick={ClickHandler} to="/contact" className="theme-btn-s2">Prendre rendez-vous</Link>
                        </div>
                    </div>
                    <div className="col-lg-6">
                        <div className="hero-images">
                            <div className="main-image">
                                <img src={Img1} alt="Laura Perillo avec un chien - Éducation canine" />
                            </div>
                            <div className="secondary-image">
                                <img src={Img2} alt="Séance d'éducation canine" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="paw-1"><img src={paws1} alt="paw shape 1" /></div>
            <div className="paw-2"><img src={paws2} alt="paw shape 2" /></div>
            <div className="paw-3"><img src={paws3} alt="paw shape 3" /></div>
            <div className="paw-4"><img src={paws4} alt="paw shape 4" /></div>
        </section>
    );
}

export default Hero;
